import React from "react";
import Dictionary from "./Dictionary.js";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Dictionary />
        <div className="footer">
          Coded by{" "}
          <a href="https://github.com/TinyDotPink/dictionary">Christine</a>
        </div>
      </div>
    </div>
  );
}
